import T, { useTranslate } from '@/components/Helpers/Translate'
import { Button } from '@/components/_ui/Button'
import type {
  CosmicProductType,
  CosmicVariationType,
} from '@/lib/cms/cosmic/types/CosmicProductType'
import { useGetMeReferralCode } from '@/lib/hooks/services/useGetMeReferralCode'
// TODO: comment this out once the Mixpanel with the focus mode share button is accounted for
// import { getTerms } from '@/lib/hooks/services/useGetTerms'
// import { mixpanelService } from '@/lib/services/mixpanel/initializeMixPanel'
// import { MixpanelEvent } from '@/lib/services/mixpanel/mixpanelEvent'
import { cn } from '@/lib/utils'
import Image from 'next/image'
import React from 'react'
import { useModals } from '@/components/ModalManager/useModals'
import { useExclusiveProduct } from '@/lib/hooks/helpers/useExclusiveProduct'
import useGlobalStore from '@/store/useGlobalStore'
import { useCopyReferralLink } from '@/lib/hooks/helpers/useCopyReferralLink'
import { SelectLinkType } from './SelectLinkType'

type Props = {
  className?: string
  selectedVariation: CosmicVariationType
  product: CosmicProductType
}

const ProductShareButton = ({
  className,
  selectedVariation,
  product,
}: Props) => {
  const { isLoadingMeReferralCode } = useGetMeReferralCode()
  const { translate } = useTranslate()
  const { user } = useGlobalStore()
  const { modals } = useModals()
  const { isExclusiveProduct } = useExclusiveProduct({
    exclusiveLockedContentData: product.exclusiveLockedContentData,
  })
  const { copyReferralLink } = useCopyReferralLink()

  const handleOpenReferralLinkModal = () => {
    if (isExclusiveProduct) {
      copyReferralLink({ type: 'standard' })
      return
    }
    modals.openModal({
      type: 'modal',
      modalId: 'share_referral_link',
      modal: {
        title: translate('choose_your_link'),
        titleStyles: 'text-left',
        className: 'max-w-md',
        children: (
          <SelectLinkType
            product={product}
            selectedVariation={selectedVariation}
          />
        ),
      },
    })
  }

  if (isLoadingMeReferralCode) return null

  return (
    <div>
      {!isLoadingMeReferralCode && user.customerType !== 'Customer' && (
        <Button
          variant="icon"
          className={cn(
            'z-50 mt-2 mb-2 rounded-full bg-[#E9EFF5] p-4 hover:bg-[#E9EFF5]',
            className,
          )}
          data-test="product-share-button"
          onClick={() => {
            handleOpenReferralLinkModal()
          }}
        >
          <Image src="/icons/share.svg" height={16} width={16} alt="Cart" />
          <span className="ml-2 text-[#003764]">
            <T>share_with_referral</T>
          </span>
        </Button>
      )}
    </div>
  )
}

export default ProductShareButton
